import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
  MenuItem, Select, InputLabel 
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";

import { muiAbtn, muiBbtn } from "./style";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import CreativeImage from "./CreativeImage";
import {
  collection,
  where,
  getDocs,
  setDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function AllCodes() {
  const [rows, setRows] = useState([]);
  const [isupdate, setisupdate] = useState(false);
  const [loading, setLoading] = useState(false); ///To check if data if loaded or not from collection.
  const [isProcessing, setisProcessing] = useState(false);
  const [openMission, setOpenMission] = useState(false);
  const [open, setOpen] = useState(false);
  const [Code, setCode] = useState("");
  const [CodeType, setCodeType] = useState("");
  const [Name, setName] = useState("");
  const [DocId, setDocId] = useState("");
  const [openDialog, setOpenDialog] = useState(false);

  const navigate = useNavigate();
  const getData = () => {
    setLoading(true);

    const q = query(collection(db, "code"), orderBy("type", "asc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const updatedRows = [];
      snapshot.forEach((document) => {
        updatedRows.push({
          id: document.id,
          ...document.data(),
        });
      });
      setRows(updatedRows);
      setLoading(false);
    });

    return unsubscribe;
  };

  // ...

  useEffect(() => {
    let unsubscribe;
    let active = true;

    if (active) {
      unsubscribe = getData();
    }

    return () => {
      active = false;
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  const handleOpen = () => {
    setOpen(true);
    setName("");
  };


  const handleOpenUpdate = (
    type = "",
    code = "",
    id = "",
  ) => {
    setisupdate(true);
    setCodeType(type);
    setCode(code);
    setDocId(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setName("");
    setisupdate(false);
    setisProcessing(false);
  };
  const handleCloseMission = () => {
    setOpenMission(false);
    setName("");
    setisupdate(false);
    setisProcessing(false);
  };

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setDocId(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDocId("");
    setisProcessing(false);
  };

  const deleteCode = () => {
    setisProcessing(true);
    deleteDoc(doc(db, "code", DocId))
      .then(() => {
        toast.info("Code Deleted");
        handleCloseDialog();
        setRows(rows.filter((row) => row.id !== DocId));
      })
      .catch((error) => {
        handleCloseDialog();
        toast.error("Error! Unable to Delete Code");
        console.log(error);
      });
  };

 
  const addCode = async () => {
    if (!Code || !CodeType) {
      toast.error("Code number and duration are required");
      return;
    }
  
    setisProcessing(true);
    const data = {
      code: Code,
      type: CodeType,
    };
  
    try {
      // Query Firestore to check for existing code with the same type and code
      const querySnapshot = await getDocs(
        query(
          collection(db, "code"),
          where("code", "==", Code),
          where("type", "==", CodeType)
        )
      );
  
      if (!querySnapshot.empty) {
        // If a matching document exists, show a toast and return early
        toast.error("Code with this type already exists");
        setisProcessing(false);
        return;
      }
  
      if (isupdate) {
        await updateDoc(doc(db, "code", DocId), data);
        handleClose();
        handleCloseMission();
        toast.success("Code Updated");
      } else {
        const newDoc = doc(collection(db, "code"));
        const doc_id = newDoc.id;
        data["id"] = doc_id;
        await setDoc(newDoc, data);
        handleClose();
        handleCloseMission();
        toast.success("Code Added");
      }
    } catch (error) {
      handleClose();
      handleCloseMission();
      toast.error("Error! Unable to process the code");
      console.error(error);
    } finally {
      setisProcessing(false);
    }
  };
  

  const columns = [
    // { field: "id", headerName: "ID", width: "60" },
    {
      field: "code",
      headerName: "",
      width: "250",
      align: "left",
    },
    {
      field: "type",
      headerName: "",
      width: "100",
      align: "left",
    },
    {
      field: "email",
      headerName: "",
      width: "350",
      align: "left",
    },
    {
      field: "start",
      headerName: "",
      width: "110",
      align: "left",
      valueFormatter: (params) => formatTimestamp(params.value),
    },
    {
      field: "end",
      headerName: "",
      width: "110",
      align: "left",
      valueFormatter: (params) => formatTimestamp(params.value),
    },

    {
      field: "Action",
      width: "200",
      align: "right",

      editable: false,
      renderCell: ActionButton,
    },
  ];

  function ActionButton(params) {
    return (
      <>
        
       {params.row.start == null && params.row.end == null &&  <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          // startIcon={<CheckCircleIcon />}
          onClick={() => {
            handleOpenUpdate(
              params.row.type,
              params.row.code,
              params.row.id,
            );
          }}
        >
          Edit
        </Button>}
        {params.row.start == null && params.row.end == null && 
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          onClick={() => handleClickOpen(params.row.id)}
          // startIcon={<CancelIcon />}
        >
          Delete
        </Button>}
      </>
    );
  }



  const formatTimestamp = (timestamp) => {
    if (!timestamp) return ""; // Handle null or undefined timestamps
    const date = timestamp.toDate();
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(date);
  };

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,
        backgroundColor: "#212C62",
      }}
    >
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to Delete the Code?"}
        </DialogTitle>

        {isProcessing ? (
          <LinearProgress />
        ) : (
          <DialogActions>
            <Button onClick={() => deleteCode()}>Yes</Button>
            <Button onClick={handleCloseDialog} autoFocus>
              No
            </Button>
          </DialogActions>
        )}
      </Dialog>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form>
            <Box style={{ display: "flex", justifyContent: "end" }}>
              <CloseIcon
                onClick={handleClose}
                style={{ cursor: "pointer", color: "gray" }}
              />
            </Box>
            <h2 className="mb-4" style={{ color: "#212C62" }} mb={3}>
              {!isupdate ? "Add New Code" : "Update Code"}
            </h2>

            <FormControl fullWidth size="small">
              <TextField
                className="mb-4"
                id="outlined-basic"
                label="Enter Unique Code"
                variant="outlined"
                size="small"
                fullWidth
                value={Code}
                onChange={(e) => setCode(e.target.value)}
              />
            </FormControl>
            <FormControl fullWidth size="small">
            <InputLabel id="code-type-label">Code Type</InputLabel>
      <Select
        labelId="code-type-label"
        id="code-type-select"
        value={CodeType}
        onChange= {(e) => setCodeType(e.target.value)}
        label="Code Type"
      >
        <MenuItem value="Monthly">Monthly</MenuItem>
        <MenuItem value="Yearly">Yearly</MenuItem>
      </Select>
            </FormControl>
            <Button
              fullWidth
              className="mt-2 muibtn"
              variant="contained"
              color="primary"
              size="small"
              style={muiBbtn}
              disabled={isProcessing}
              onClick={() => addCode()}
            >
              {isProcessing ? (
                <CircularProgress sx={{ color: "white" }} size={27} />
              ) : (
                <>
                  <AddIcon style={{ marginRight: 10 }} />
                  {!isupdate ? "Add Code" : "Update Code"}
                </>
              )}
            </Button>
          </form>
        </Box>
      </Modal>
      
      

      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6">
            <h1
              className="mb-4 py-4"
              style={{ textAlign: "left", color: "#212C62" }}
            >
              <b>Subscription Codes</b>
            </h1>
            <Button
              variant="contained"
              color="primary"
              style={muiBbtn}
              size="small"
              // startIcon={<CheckCircleIcon />}
              onClick={() => handleOpen()}
            >
              Add New Code
            </Button>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>All Codes</b>
          </h5>
          <DataGrid
            style={{ height: "65vh", width: "100%" }}
            columns={columns}
            rows={rows}
            // getRowId={(Rows) => Rows._id}
            pageSize={12}
            rowsPerPageOptions={[12]}
            loading={loading}
            disableColumnMenu={true}
            headerHeight={0}
            getRowSpacing={(params) => ({
              top: params.isFirstVisible ? 10 : 8,
              bottom: params.isLastVisible ? 0 : 8,
            })}
            disableSelectionOnClick
          />
        </div>
      </Card>
    </div>
  );
}
